export default "/assets/confetti.svg";